// Public payment page. Thin wrapper around the shared RazorpayPaymentPanel,
// which owns the token exchange → begin → modal → verify lifecycle.
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { SiteLayout } from "@/components/SiteLayout";
import { Section } from "@/components/Section";
import { RazorpayPaymentPanel } from "@/components/payments/RazorpayPaymentPanel";

const searchSchema = z.object({ token: z.string().optional() });

export const Route = createFileRoute("/order/pay")({
  head: () => ({
    meta: [
      { title: "Pay for your order — Poonam Kapur Healthy Kitchen" },
      { name: "robots", content: "noindex, nofollow" },
      { name: "referrer", content: "no-referrer" },
    ],
  }),
  validateSearch: (raw) => searchSchema.parse(raw),
  component: PayPage,
});
function PayPage() {
  const { token } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <SiteLayout>
      <PayHero />
      <Section>
        <RazorpayPaymentPanel
          token={token}
          cleanUrl="/order/pay"
          successActions={() => (
            <Link
              to="/"
              className="mt-6 inline-flex items-center justify-center rounded-md border px-4 py-2 text-sm"
            >
              Back to home
            </Link>
          )}
          errorActions={() => (
            <button
              type="button"
              onClick={() => void navigate({ to: "/order" })}
              className="inline-flex items-center justify-center rounded-md border px-4 py-2 text-sm"
            >
              Back to order form
            </button>
          )}
        />
      </Section>
    </SiteLayout>
  );
}

function PayHero() {
  return (
    <section className="border-b bg-secondary/30 py-8">
      <div className="mx-auto max-w-xl px-4">
        <h1 className="text-2xl font-semibold">Secure payment</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Powered by Razorpay
        </p>
      </div>
    </section>
  );
}